<svg *ngIf="total > 0"
     class="success-pie"
     viewBox="0 0 20 20"
     [ngbTooltip]="tooltip"
     container="body"
     tooltipClass="success-tooltip">
    <g transform="rotate(-90 10 10)">
        <circle class="pie-track" cx="10" cy="10" [attr.r]="radius"></circle>
        <circle *ngFor="let slice of slices"
                [ngClass]="slice.className"
                cx="10"
                cy="10"
                [attr.r]="radius"
                [attr.stroke-dasharray]="slice.dashArray"
                [attr.stroke-dashoffset]="slice.dashOffset"></circle>
    </g>
</svg>
